import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Cam from './Cam.js';
import Button from '@material-ui/core/Button';
import Countdown from 'react-countdown';
import { useHistory } from "react-router-dom";
import { useSnackbar } from 'notistack';
import {isMobile} from "react-device-detect";
import Config from "../config.json"
import Resizer from "react-image-file-resizer";

const useStyles = makeStyles((theme) => ({
  
  botonEnviar: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    color: 'white',
    fontSize:'18px',
    fontWeight: 600,
  },
  alerta: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


export default function EnvioAviso(props) {
  const [foto, setFoto] = React.useState();
  const [base64, setBase64] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const classes = useStyles();


  function Completionist(){
    const classes = useStyles();

    return (
      <Alert className={classes.alerta} variant="filled" severity="success">
        Se encuentra en horario de depósito, puede depositar <b>ahora</b> sus residuos.
      </Alert>
    )
  } 

 


  function onPhotoSelected(foto) {
    setFoto(foto)
    resizeFile(foto)
    .then(function(base64){
      setBase64(base64)
      console.log(base64)   
    })  
    setTimeout(() => {
      scrollBottom()      
    }, 1000);   
  }

  const onConfirmarClick = (event) => {  
    onEnviarClick()
  }

  const onEnviarClick = (event) => {      
    getBase64(foto)
    .then(data =>enviarAvisoRecogida(data))
    .catch(function(){enviarAvisoRecogida(null)})   
    setLoading(true)
    

  function enviarAvisoRecogida(){
    fetch(Config.SERVER_URL + 'generarAviso/', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf8'
      },
    
      body: JSON.stringify({
        latitud: props.position.coords.latitude, 
        longitud: props.position.coords.longitude,         
        tipo: props.tipo,
        foto: base64})
    })    
    .then(response => response.json())
    .then(function(data) {
      setTimeout(() => {
        setLoading(false)
        setFoto()
        props.clear()   
        enqueueSnackbar('El aviso de recogida se ha creado con éxito.', { variant:'success' })
        history.push("/gracias");
            
      }, 500);      
    })
    .catch(function(){ 
      setTimeout(() => {
        setLoading(false)
        enqueueSnackbar('Se produjo un error creando el aviso de recogida.',{variant: 'error'});
      }, 500);        
    })        
    }
  }

  const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1024,
      576,
      "JPEG",
      100,
      0,
      (uri) => {         
        resolve(uri.replace(/^.*,/, ''))
      },
      "base64"
    );
  });

  function scrollBottom(){
    window.scrollTo(0,document.body.scrollHeight);
  }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.replace(/^.*,/, ''));
      reader.onerror = error => reject(error);
    });
  }


  const renderFun = ({days,hours, minutes, seconds, completed }) => {
    var horas = hours.toString().padStart(2,"00")
    var minutos = minutes.toString().padStart(2,"00")
    var segundos = seconds.toString().padStart(2,"00")
    var mensaje = `${days} días y ${horas}:${minutos}:${segundos} horas`
    if(days === 0)
      mensaje = `${horas}:${minutos}:${segundos}`
    if (completed || props.ayuntamientos) {
      // Render a completed state
      return <div>
          <Completionist />
          {isMobile &&
          <Cam fotoUrl={url} setFoto={(foto) => onPhotoSelected(foto)}/>}
          {isMobile &&
          <Button className={classes.botonEnviar}
            variant="contained" 
            color="primary"
            onClick = {onConfirmarClick}>
              Solicitar recogida
          </Button>}
          <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color='primary' />
          </Backdrop>    
        </div>;
    } else {
      // Render a countdown
      return(           
        <Alert className={classes.alerta} variant="filled" severity="warning">
          El próximo periodo de depósito comienza en <b>{mensaje}</b>
        </Alert>)
    }
  };      
  const url = foto?URL.createObjectURL(foto):undefined 
  return (
    <div>
       {props.horarios && props.horarios.proximasRecogidas && <Countdown 
          date={props.horarios.proximasRecogidas[0]}
          renderer={renderFun}  />}   
    </div>          
    )    




}